module.exports = __webpack_public_path__ + "static/img/5.04a6ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/5.png
// module id = TsRu
// module chunks = 1